export { default } from './files-uploader-placeholder';
